module.exports = __webpack_public_path__ + "img/oil_paint_1.d61d3a5d.png";